import React, {FC, useEffect, useState} from "react";
import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "../../components/BackgroundSection/BackgroundSection";
import {DEMO_CATEGORIES} from "../../data/Markets";
import SectionGridCategoryBoxMarkets from "./SectionGridCategoryBoxMarkets";
import SectionMarkets from "./SectionMarkets";
import ButtonPrimary from "../../components/Button/ButtonPrimary";
import {ArrowDownIcon, ArrowUpIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";
import axios, {AxiosError, AxiosResponse} from "axios";
import SearchMarkets from "./SearchMarkets";
import {clearInterval, setInterval} from "timers";
import SectionCarousel from "./SectionCarousel";
import Input from "components/Input/Input";
import {displayToast, toastType} from "../../global/Functions";


export interface PageMarketsProps {
  className?: string;
}

const PageMarkets: FC<PageMarketsProps> = ({ className = "" }) => {
  const STEP = 15;
  const [coinsPerPage, setCoinsPerPage] = useState(15);
  const [coins, setCoins] = useState<any>([]);
  const [filteredCoins, setFilteredCoins] = useState<object[] | null | undefined>();

  let mobileView = window.matchMedia('(max-width: 1280px)');
  const [mobile, setMobile] = useState(mobileView.matches);

  mobileView.addEventListener("change", (e) => {
    setMobile(e.matches);
  })

  const fetchData = async () => {
    const url = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=gbp&order=market_cap_desc&per_page=250&page=1&sparkline=false";
    const url2 = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=gbp&order=market_cap_desc&per_page=250&page=2&sparkline=false";

    try {
      const response1 = await axios.get(url);
      const response2 = await axios.get(url2);

      setCoins(
        response1.data.map((coin: any) => {
          for (let demo of DEMO_CATEGORIES) {
            if (coin.name === demo.name) {
              return {
                count: coin.current_price,
                ...demo,
                ...coin
              }
            }
          }
          return {
            count: coin.current_price,
            thumbnail: coin.image,
            href: `coin/${coin.id}`,
            ...coin
          }
        }).concat(
          response2.data.map((coin: any) => {
            for (let demo of DEMO_CATEGORIES) {
              if (coin.name === demo.name) {
                return {
                  count: coin.current_price,
                  ...demo,
                  ...coin
                }
              }
            }
            return {
              count: coin.current_price,
              thumbnail: coin.image,
              href: `coin/${coin.id}`,
              ...coin
            }
          })
        )
      )
    } catch (error) {
      displayToast("API is down", toastType.error);
    }
  }

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => fetchData(), 60000);

    return () => {
      clearInterval(interval);
    }
  }, []);

  const filterData = (e: any) => {
    if (e === "") setFilteredCoins(null);
    else setFilteredCoins(coins?.filter((coin: any) => {
      if (e === "") return;
      if (coin.name.toLowerCase().includes(e.toLowerCase()) || coin.symbol.toLowerCase().includes(e.toLowerCase())) return coin;
    }))
  }

  const mobileSearch = () => {
    return(
      <div className=" py-10 flex justify-center flex-grow items-center space-x-3 sm:space-x-8 lg:space-x-10">
        <div className=" sm:block flex-grow max-w-xs">
          <form className="relative" onSubmit={(e) => e.preventDefault()}>
            <Input
              type="search"
              onChange={(e) => filterData(e.target.value)}
              placeholder="Search Crypto Currencies"
              className="pr-10 w-full"
              sizeClass="h-[42px] pl-4 py-3"
            />
            <span className="absolute top-1/2 -translate-y-1/2 right-3 text-neutral-500">
              <svg
                className="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 22L20 20"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              </span>
            <input type="submit" hidden value="" />
          </form>
        </div>
      </div>
    )
  }
  const desktopSearch = () => {
    return (
      <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
        <div className="hidden items-center xl:flex space-x-1">
          <SearchMarkets
            onChange={(e) => filterData(e.target.value)}
            onClickSubmit={(e) => e.preventDefault()}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={`PageMarkets  ${className}`} data-nc-id="PageMarkets">
      <Helmet>
        <title>Markets | CryptoVerse</title>
      </Helmet>
      <BgGlassmorphism />
      <SectionCarousel />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionMarkets />
        <div className="relative py-16">
          <BackgroundSection/>
          {
            mobile ? mobileSearch() : desktopSearch()
          }
          <SectionGridCategoryBoxMarkets
            categories={filteredCoins? filteredCoins : coins.slice(0, coinsPerPage)}
          />
        </div>
        <div className="justify-center flex space-x-4 mt-11">
          <ButtonPrimary onClick={() => {setCoinsPerPage((prevState) => prevState + STEP)}}
          >
            Load More <ArrowDownIcon className="w-5 h-5 ml-2"/>
          </ButtonPrimary>
          <ButtonSecondary onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}>
            Back to Top
            <ArrowUpIcon className="w-5 h-5 ml-2"/>
          </ButtonSecondary>
        </div>
      </div>
    </div>
  );
};

export default PageMarkets;
